import {Component, EventEmitter, Input, Output} from '@angular/core';
import {RestDataService} from '../../../services/rest-data.service';
import {SearchSort, SmallSelectItem} from '../../../services/common-datatypes';
import {RequiredInput} from "../../../decorators/common.decorators";

@Component({
    selector: 'app-simple-sort-select',
    templateUrl: './simple-sort-select.component.html',
    styleUrls: ['./simple-sort-select.component.scss']
})
export class SimpleSortSelectComponent {

    private readonly foreignToLocalNames: { [index: string]: string } = {
        id: 'add',
        last_edit: 'edit',
        invnr: 'invnr',
        category: 'category'
    };

    private selectColumnList: { [key: string]: SmallSelectItem } = {};

    @Input() public multiple = false;
    @Input() public wide = false;
    // strange but sortData is available to late for the RequiredInput directive here
    @Input() @RequiredInput sortData!: SearchSort;

    @Output() sortDataChange = new EventEmitter<SearchSort>();

    private translatedNames = {};

    constructor(private dataService: RestDataService) {
        this.loadData();
    }


    loadData() {
        this.dataService.getDeviceSort().then((data: SmallSelectItem[]) => {
            if (!data || (0 >= data.length)) return;
            data.forEach((item) => {
                if (!this.foreignToLocalNames[item.name]) return;
                const newItem = new SmallSelectItem();
                newItem.updateFromJson(item);
                this.selectColumnList[this.foreignToLocalNames[item.name]] = newItem;
            });
        });
    }


    isSortOrder(compare: string): boolean {
        return ((0 < this.sortData.sortItems.length)
            && (compare === this.foreignToLocalNames[this.sortData.sortItems[0].name]));
    }

    setOrder(item: string) {
        if (this.isSortOrder(item)) this.changeDirection();
        else {
            const newItem = new SmallSelectItem();
            newItem.updateFromJson(this.selectColumnList[item]);
            this.sortData.sortItems.length = 0;
            this.sortData.sortItems.push(newItem);
            this.sortData.direction = '-';
            this.sortDataChange.emit(this.sortData);
        }
    }

    changeDirection() {
        if (this.sortData.direction === '-') this.sortData.direction = '+';
        else this.sortData.direction = '-';
        this.sortDataChange.emit(this.sortData);
    }

    direction(dir: string) {
        this.sortData.direction = dir;
        this.sortDataChange.emit(this.sortData);
    }

    updateData() {
        this.sortDataChange.emit(this.sortData);
    }

}
